/* eslint-disable */
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Login.css";
import useSignIn from "react-auth-kit/hooks/useSignIn";
import { useState, useRef } from "react";
import api from "../../api";
import BetaModal from "../../components/BetaModal";
import { FaLinkedin } from "react-icons/fa";
import { themeColours } from "../../resources";
import { IoIosMail } from "react-icons/io";
import { FiEye, FiEyeOff } from "react-icons/fi";
const logo = require("../../assets/logoNoBack.png");
const loginPage = require("../../assets/loginPage.png");

export function Login() {
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    firstName: "",
    lastName: "",
    email: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const passwordRef = useRef<HTMLInputElement>(null);
  const location = useLocation();
  const currentPath = location.pathname;
  const isLogin = currentPath === "/login";
  const navigate = useNavigate();
  const signIn = useSignIn();

  async function handleForm(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setIsLoading(true);
    let res;
    try {
      const { username, password, firstName, lastName, email } = formData;
      if (isLogin) {
        localStorage.removeItem("isGuest");
        res = await api.post("/account/login", {
          username: username,
          password: password,
        });
      } else {
        res = await api.post("/account/signup", {
          firstName,
          lastName,
          username,
          password,
          email,
        });
      }
      if (res.data.accessToken) {
        const { firstName, username, lastName, userId, createdAt, email } = res.data;
        const isSignedIn = signIn({
          auth: { token: res.data.accessToken, type: "Bearer" },
          userState: { firstName, lastName, username, userId, createdAt, email },
        });
        if (isSignedIn) return navigate("/");
        return;
      }
    } catch (e) {
      console.error(`Error ${isLogin ? "loggin in" : "signing up"}`, e);
    }
    setIsLoading(false);
  }

  async function handleGuestLogin() {
    setIsLoading(true);
    localStorage.setItem("isGuest", "T");
    const res = await api.post("/account/login", {
      username: process.env.REACT_APP_G_USERNAME,
      password: process.env.REACT_APP_G_PASSWORD,
    });
    const { firstName, username, lastName, userId, createdAt, email } = res.data;
    const isSignedIn = signIn({
      auth: { token: res.data.accessToken, type: "Bearer" },
      userState: { firstName, lastName, username, userId, createdAt, email },
    });
    if (isSignedIn) return navigate("/");
  }

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    e.preventDefault();
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  }

  function handleShowPassword() {
    const newShowPassword = !showPassword;
    setShowPassword(newShowPassword);
    if (passwordRef.current) {
      passwordRef.current.type = newShowPassword ? "text" : "password";
    }
  }

  return (
    <div className="appContainer">
      <div className="loginPageContainer">
        <img src={loginPage} alt="background" className="background" style={{ objectFit: "fill" }} />
        {/* <BetaModal isStandalone={true} /> */}
        <form onSubmit={handleForm} className="formContainer">
          <img src={logo} width={75}></img>
          <h1 className="loginHeader">Pick and Price</h1>
          {isLogin ? (
            <>
              <input type="text" name="username" placeholder="Username" onChange={(e) => handleChange(e)} />
            </>
          ) : (
            <>
              <span>
                <input
                  type="text"
                  name="firstName"
                  placeholder="Name"
                  onChange={(e) => handleChange(e)}
                  style={{ marginRight: "8px" }}
                />
                <input type="text" name="lastName" placeholder="Surname" onChange={(e) => handleChange(e)} />
              </span>
              <input type="text" name="username" placeholder="Username" onChange={(e) => handleChange(e)} />
              <input type="text" name="email" placeholder="Email" onChange={(e) => handleChange(e)} />
            </>
          )}
          <span className="editUserPasswordSpanLogin">
            <input
              type="password"
              name="password"
              placeholder="Password"
              onChange={(e) => handleChange(e)}
              ref={passwordRef}
            />
            {showPassword ? (
              <FiEye size={15} color={themeColours.primary} onClick={handleShowPassword} />
            ) : (
              <FiEyeOff size={15} color={themeColours.primary} onClick={handleShowPassword} />
            )}
          </span>
          {isLogin ? (
            <p className="loginLinkText">
              Don't have an account?{" "}
              <Link to="/signup" className="loginLink">
                Sign up
              </Link>
            </p>
          ) : (
            <p className="loginLinkText">
              Already a user?{" "}
              <Link to="/login" className="loginLink">
                Log in
              </Link>
            </p>
          )}
          {isLoading ? (
            <div className="spinner spinner_small"></div>
          ) : (
            <>
              <button type="submit" className="primaryButton loginButton">
                {isLogin ? "Login" : "Sign up"}
              </button>
              <button type="button" className="primaryButton loginButton" onClick={handleGuestLogin}>
                Enter as guest
              </button>
            </>
          )}
          <span className="loginSocialSpan">
            <a href="https://www.linkedin.com/company/107177905">
              <FaLinkedin color={themeColours.primary} size={30} />
            </a>
            <a href="mailto:operations@pickandprice.co.za">
              <IoIosMail color={themeColours.primary} size={40} />
            </a>
          </span>
        </form>
      </div>
    </div>
  );
}
